export const Box = () => {
  const features = [
    { text: "Personalised Feed" },
    { text: "Zero Ads" },
    { text: "Instant Alerts" },
    { text: "Local Deals" }

  ];

  return (
    <div>
      <div className="hidden lg:block">
        <section className="w-full flex justify-center">

          {/* MAIN CARD */}
          <div
            className="
        relative
        w-full
        max-w-[1700px]
        rounded-[40px]
        shadow-[0px_0px_35px_rgba(0,0,0,0.08)]
        px-[80px]
        py-[80px]
        flex
        items-center
        justify-between
        gap-12
        overflow-visible
      "
            style={{ background: "radial-gradient(ellipse at top left, #ffe9b0 0%, #fffdf5 55%, #ffffff 100%)" }}
          >

            {/* LEFT SIDE */}
            <div className="max-w-[720px]">

              {/* label */}
              <div className="flex items-center gap-3 mb-6">

                <div className="w-[10px] h-[10px] rounded-full bg-gradient-to-r from-red-600 to-red-900" />

                <span className="text-[18px] text-gray-700">
                  Personalised for You
                </span>

              </div>


              {/* heading */}
              <h2 className="text-[40px] leading-[1.15] font-normal text-neutral-900 mb-6">

                Follow Businesses You Love and
                <br />
                <span className="font-bold">Discover Deals That Matter.</span>

              </h2>


              {/* paragraph */}
              <p className="text-gray-600 text-lg leading-[30px] mb-10">

                Connect with the local businesses you love by following them directly in the app. Their latest offers will build your personalized feed, giving you instant access to the Deals That Matter, without annoying ads or distractions
              </p>


              {/* FEATURES */}
              <div className="grid grid-cols-2 gap-y-6 mb-10">

                {features.map((feature, i) => (

                  <div key={i} className="flex items-center gap-3">

                    <div className="
                  w-[22px]
                  h-[22px]
                  rounded-full
                  bg-gradient-to-r
                  from-red-600
                  to-red-900
                  flex
                  items-center
                  justify-center
                ">

                      <img
                        src="/images/vector-7.svg"
                        className="w-[12px]"
                      />

                    </div>

                    <span className="text-[20px] text-neutral-900">
                      {feature.text}
                    </span>

                  </div>

                ))}

              </div>


              {/* STORE BUTTONS */}
              <div className="flex gap-4">

                {/* APP STORE */}
                <a
                  href="https://couponbook.app.link/BsnZ5PEfH2b"
                  target="_blank"
                  className="flex items-center justify-center h-14 px-6 bg-black rounded-full" rel="noreferrer"
                >
                  <img
                    src="/images/AppleLogo.webp"
                    className="w-[150px]"
                  />
                </a>



                {/* GOOGLE PLAY */}
                <a
                  href="https://couponbook.app.link/BsnZ5PEfH2b"
                  target="_blank"
                  className="flex items-center justify-center h-14 px-6 bg-black rounded-full" rel="noreferrer"
                >
                  <img
                    src="/images/rectangle-34625679.webp"
                    className="w-[150px]"
                  />
                </a>

              </div>

            </div>


            {/* RIGHT SIDE PHONE */}
            <div className="relative flex justify-center items-center" style={{ width: "clamp(880px, 45vw, 850px)" }}>

              {/* PHONE */}
              <img
                src="/images/Webp/Mobile1.webp"
                className="relative z-10"
                style={{ width: "clamp(250px, 25vw, 360px)" }}
              />

              {/* NEW DEAL ALERT CARD */}
              <div
                className="absolute transbox overflow-hidden border-4 border-solid border-white animate-floatSlow z-30"
                style={{
                  top: "clamp(30px, 6vw, 90px)",
                  right: "clamp(-60px, -8vw, -120px)",
                  width: "clamp(140px, 18vw, 300px)",
                  borderRadius: "clamp(16px, 2vw, 30px)",
                  boxShadow: "0px 40px 80px rgba(0,0,0,0.25)",
                }}
              >
                {/* TOP RED SECTION */}
                <div
                  className="relative bgimg bg-cover bg-center text-white"
                  style={{
                    padding: "clamp(10px, 1.5vw, 24px)",
                    margin: "4px",
                    borderRadius: "clamp(14px, 1.8vw, 28px)",
                  }}
                >
                  <div className="absolute inset-0" />
                  <div
                    className="relative z-10 font-semibold mb-1"
                    style={{ fontSize: "clamp(11px, 1.2vw, 20px)" }}
                  >
                    New deal alert
                  </div>
                  <div
                    className="relative z-10 opacity-90 leading-relaxed font-normal"
                    style={{ fontSize: "clamp(9px, 0.9vw, 14px)" }}
                  >
                    A local spot you follow just dropped a brand new offer. Tap to check it out!
                  </div>
                </div>

                {/* BOTTOM WHITE SECTION */}
                <div style={{ padding: "clamp(8px, 1vw, 20px) clamp(10px, 1.5vw, 24px)" }}>
                  <div
                    className="font-semibold text-black"
                    style={{ fontSize: "clamp(10px, 1.1vw, 18px)" }}
                  >
                    +120 Points Added
                  </div>
                </div>
              </div>

              {/* NOW FOLLOWING CARD */}
              <div
                className="absolute flex items-center transbox backdrop-blur-xl border-solid border-white animate-floatSlowReverse z-20"
                style={{
                  bottom: "clamp(20px, 4vw, 60px)",
                  left: "clamp(-60px, -10vw, -180px)",
                  gap: "clamp(8px, 1vw, 16px)",
                  padding: "clamp(8px, 1vw, 16px) clamp(10px, 1.5vw, 20px)",
                  borderRadius: "clamp(12px, 1.8vw, 26px)",
                  borderWidth: "clamp(2px, 0.3vw, 4px)",
                  boxShadow: "0px 40px 80px rgba(0,0,0,0.18)",
                }}
              >
                {/* PROFILE IMAGE */}
                <img
                  src="/images/Webp/rectangle-34625668.webp"
                  className="object-cover border-2 border-white flex-shrink-0"
                  style={{
                    width: "clamp(32px, 4vw, 64px)",
                    height: "clamp(32px, 4vw, 64px)",
                    borderRadius: "clamp(8px, 1vw, 15px)",
                  }}
                />

                {/* TEXT */}
                <div>
                  <div
                    className="font-semibold text-black"
                    style={{ fontSize: "clamp(10px, 1.1vw, 18px)" }}
                  >
                    Now Following!
                  </div>
                  <div
                    className="font-normal text-gray-600"
                    style={{
                      fontSize: "clamp(8px, 0.85vw, 14px)",
                      maxWidth: "clamp(80px, 12vw, 220px)",
                    }}
                  >
                    You'll now see their latest deals right in your personalized feed.
                  </div>
                </div>
              </div>

            </div>


          </div>



          {/* ANIMATIONS */}
          <style>{`

   

            div.transbox {
              background-color: rgba(255, 231, 231, 0.4);
              -webkit-backdrop-filter: blur(5px);
              backdrop-filter: blur(5px);
              
              font-weight: bold;
            }


                    .bgimg {
                background-image: url('/images/Webp/PersonalisedforYouRedCardBG.webp');
                background-size: cover;
              background-position: center;
              background-repeat: no-repeat;
            }
        @keyframes floatSlow {
          0%,100% {
            transform: translateY(0px);
          }
          50% {
            transform: translateY(-16px);
          }
        }

        @keyframes floatSlowReverse {
          0%,100% {
            transform: translateY(-10px);
          }
          50% {
            transform: translateY(10px);
          }
        }

        .animate-floatSlow {
          animation: floatSlow 6s ease-in-out infinite;
        }
          .animate-floatSlowDelay {
          animation: floatSlow 5s ease-in-out infinite;
        }

        .animate-floatSlowReverse {
          animation: floatSlowReverse 7s ease-in-out infinite;
        }

      `}</style>


        </section>
      </div>

      {/* TABLET + MOBILE — stacked card, same structure as the "Save for later" section */}
      <div className="block lg:hidden">
        <section className="w-full flex justify-center">
          <div className="w-full max-w-[420px]">
            <div
              className="rounded-[28px] px-[20px] py-[32px] flex flex-col items-center text-center"
              style={{ background: "radial-gradient(ellipse at top left, #ffe9b0 0%, #fffdf5 55%, #ffffff 100%)" }}
            >
              {/* LABEL */}
              <div className="flex items-center gap-[8px] mb-[12px]">
                <div className="w-[10px] h-[10px] rounded-full bg-gradient-to-r from-red-600 to-red-900" />
                <span className="text-[18px] text-gray-600 font-medium">Personalised for You</span>
              </div>

              {/* TITLE */}
              <h2 className="text-[20px] leading-[34px] font-semibold text-black mb-[12px] px-6">
                Follow Businesses You Love and Discover Deals That Matter.
              </h2>

              {/* DESCRIPTION */}
              <p className="text-[12px] leading-[20px] text-gray-600 px-[8px] mb-0">
                Connect with the local businesses you love by following them directly in the app. Their latest offers will build your personalized feed, giving you instant access to the Deals That Matter, without annoying ads or distractions
              </p>

              {/* PHONE + FLOATING CARDS */}
              <div className="relative flex justify-center mt-[24px]">
                <img
                  src="/images/Webp/Mobile1.webp"
                  alt="Personalised feed in the My Couponbook app"
                  className="w-[220px] relative z-10"
                />

                {/* NEW DEAL ALERT CARD */}
                <div className="absolute top-[30px] right-[-60px] w-[180px] rounded-[20px] overflow-hidden transbox border-[4px] border-solid border-white shadow-[0px_40px_80px_rgba(0,0,0,0.25)] animate-floatSlow z-30 text-left">
                  <div className="relative bgimg rounded-[16px] bg-cover bg-center text-white m-[4px] p-[12px]">
                    <div className="relative z-10 text-[12px] font-semibold mb-[4px]">New deal alert</div>
                    <div className="relative z-10 font-normal text-[8px] opacity-90 leading-relaxed">
                      A local spot you follow just dropped a brand new offer. Tap to check it out!
                    </div>
                  </div>
                  <div className="px-[16px] py-[8px]">
                    <div className="text-[12px] font-semibold text-black">+120 Points Added</div>
                  </div>
                </div>

                {/* NOW FOLLOWING CARD */}
                <div className="absolute bottom-[60px] left-[-60px] flex items-center gap-[12px] px-[16px] py-[12px] rounded-[22px] transbox backdrop-blur-xl border-[4px] border-solid border-white shadow-[0px_40px_80px_rgba(0,0,0,0.18)] animate-floatSlowReverse z-20 text-left">
                  <img
                    src="/images/Webp/rectangle-34625668.webp"
                    alt=""
                    className="w-[40px] h-[40px] rounded-[8px] object-cover border-[2px] border-white flex-shrink-0"
                  />
                  <div>
                    <div className="font-semibold text-[12px] text-black">Now Following!</div>
                    <div className="font-normal text-[8px] text-gray-600 max-w-[110px]">
                      You'll now see their latest deals right in your personalized feed.
                    </div>
                  </div>
                </div>
              </div>

              {/* FEATURES CARD */}
              <div className="relative z-30 w-full -mt-[30px] mb-[24px] bg-white rounded-[20px] px-[20px] py-[16px] grid grid-cols-2 gap-x-[12px] gap-y-[12px]">
                {features.map((feature) => (
                  <div key={feature.text} className="flex items-center gap-[8px] text-left">
                    <div className="w-[16px] h-[16px] rounded-full bg-red-600 flex items-center justify-center flex-shrink-0">
                      <svg xmlns="http://www.w3.org/2000/svg" className="w-[12px] h-[12px] text-white" viewBox="0 0 20 20" fill="currentColor">
                        <path
                          fillRule="evenodd"
                          d="M16.704 5.29a1 1 0 010 1.42l-7.25 7.25a1 1 0 01-1.42 0l-3.25-3.25a1 1 0 111.42-1.42l2.54 2.54 6.54-6.54a1 1 0 011.42 0z"
                          clipRule="evenodd"
                        />
                      </svg>
                    </div>
                    <span className="text-[13px] text-gray-800">{feature.text}</span>
                  </div>
                ))}
              </div>

              {/* STORE BUTTONS */}
              <div className="flex flex-col gap-[12px] w-full">
                <a
                  href="https://couponbook.app.link/BsnZ5PEfH2b"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Download on the App Store"
                  className="flex items-center justify-center h-[52px] w-full bg-black rounded-full"
                >
                  <img src="/images/AppleLogo.webp" alt="Download on the App Store" className="w-[130px]" />
                </a>
                <a
                  href="https://couponbook.app.link/BsnZ5PEfH2b"
                  target="_blank"
                  rel="noreferrer"
                  aria-label="Get it on Google Play"
                  className="flex items-center justify-center h-[52px] w-full bg-black rounded-full"
                >
                  <img src="/images/rectangle-34625679.webp" alt="Get it on Google Play" className="w-[130px]" />
                </a>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};
